import KKey from 'keyboard-key'

export function initInfoLayout() {
    const root = document.querySelector('.infoArticles'),
          siteFooter = document.getElementById('siteFooter')
    if (root && siteFooter) {
        initInfoLayoutInstance(root, siteFooter)
    }
}


/**
 *
 * @param {HTMLElement} root
 * @param {HTMLElement} scrollTerminator
 */
export function initInfoLayoutInstance(root, scrollTerminator) {
    const sidebar = root.querySelector('.infoArticles-sidebar'),
          sidebarToggler = document.querySelector('.siteHeader-mobile .-toggler'),
          anchors = [].slice.apply(sidebar.querySelectorAll('.-blockList-anchor')),
          entries = [].slice.apply(sidebar.querySelectorAll('.-entry')).map(entry => ({
              button: entry.querySelector('.-entryButton'),
              list: entry.querySelector('.-entryList'),
              subLinks: [].slice.apply(entry.querySelectorAll('.-itemLink')),
              anchors: anchors.filter(a => entry.contains(a)),
              el: entry,
          })),
          allTriggers = [].slice.apply(root.querySelectorAll('a, button'))

    initAccordion()
    initAnchors()
    initSidebarObserver()

    allTriggers.forEach(trigger => {
        trigger.addEventListener('keydown', event => {
            const tabbable = allTriggers.filter(t => parseInt(t.getAttribute('tabindex')) >= 0),
                  selfIdx = tabbable.findIndex(t => t === trigger)

            switch (KKey.getCode(event)) {
                case KKey.ArrowUp:
                    if (typeof selfIdx !== 'undefined' && tabbable[selfIdx - 1]) {
                        tabbable[selfIdx - 1].focus()
                    } else {
                        tabbable[tabbable.length - 1].focus()
                    }
                    break
                case KKey.ArrowDown:
                    if (typeof selfIdx !== 'undefined' && tabbable[selfIdx + 1]) {
                        tabbable[selfIdx + 1].focus()
                    } else {
                        tabbable[0].focus()
                    }
                    break
                case KKey.Enter:
                case KKey.ArrowRight:
                case KKey.ArrowLeft:
                    trigger.click()
                    break
                default:
                    return true
            }
            event.preventDefault()
        })
    })

    function initAccordion() {
        entries.forEach(({ button, list, el, subLinks, anchors }) => {
            let isActive = el.classList.contains('is--active')

            if (isActive) {
                open()
            }

            button.addEventListener('click', toggle)

            function toggle() {
                isActive ? close() : open()
            }
            function open() {
                el.classList.add('is--open')
                list.style.height = list.scrollHeight + 'px'
                subLinks.concat(anchors).forEach(lnk => lnk.setAttribute('tabindex', '0'))
                button.setAttribute('aria-expanded', 'true')
                isActive = true
            }
            function close() {
                el.classList.remove('is--open')
                list.style.height = ''
                subLinks.concat(anchors).forEach(lnk => lnk.setAttribute('tabindex', '-1'))
                button.setAttribute('aria-expanded', 'false')
                button.focus()
                isActive = false
            }
        })
    }

    function initAnchors() {
        anchors.forEach(anchor => {
            const targetId = anchor.href.replace(/^.*#(.*$)/, '$1'),
                  target = document.getElementById(targetId)

            if (target) {
                anchor.addEventListener('click', event => {
                    event.preventDefault()
                    window.scrollTo({
                        top: window.pageYOffset + target.getBoundingClientRect().top - 150,
                        left: 0,
                        behavior: 'smooth',
                    })
                    if (sidebarToggler && sidebar.classList.contains('is--open')) {
                        sidebar.classList.remove('is--open')
                        sidebarToggler.classList.remove('is-active');
                        sidebarToggler.setAttribute('aria-expanded', 'false');
                        sidebarToggler.setAttribute('aria-label', 'Öppna undermeny');
                    }
                })
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            anchor.classList.add('is--active')
                        } else {
                            anchor.classList.remove('is--active')
                        }
                    })
                }, { rootMargin: '0px', threshold: 0 })

                observer.observe(target)
            }
        })
    }

    function initSidebarObserver() {
        const terminatorObserver = new IntersectionObserver(observerTerminator, {
            rootMargin: '0px',
            threshold: 0,
        })

        terminatorObserver.observe(scrollTerminator)

        function observerTerminator(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    sidebar.classList.add('snap-to-bottom')
                } else {
                    sidebar.classList.remove('snap-to-bottom')
                }
            })
        }
    }
}
